import React, { useContext } from 'react';
import Select from '../../engine/SelectEngine';
import styled from 'styled-components/macro';
import { FormContext } from '../FormContext';

const OTClassicFormFieldSelect = styled(Select)`
  && {
    border-color: rgba(0, 0, 0, 0.23);
    border-style: solid;
    border-width: 1px;
    width: 100%;
    max-width: initial;
    padding: 0;
    padding-right: 0.6rem;
    margin: 0;
    font-size: 14px;
  }

  input {
    padding: 0.5em 0.8em;
  }

  &:hover {
    border-color: #000;
  }
`;

const DropDownFieldView = props => {
  const { variant } = useContext(FormContext);

  return (
    <OTClassicFormFieldSelect
      searchable
      disabled={props.readOnly}
      placeholder="forms.field.dropdown.placeholder"
      options={props.options}
      value={props.value}
      onChange={props.onChange}
      variant={variant}
      inputProps={{ id: props.internalId }}
    />
  );
};

export default DropDownFieldView;
